import { render, staticRenderFns } from "./Dashboard_Desktop.vue?vue&type=template&id=ab0f23d4&scoped=true&"
import script from "./Dashboard_Desktop.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Desktop.vue?vue&type=style&index=0&id=ab0f23d4&prod&lang=css&"
import style1 from "./Dashboard_Desktop.vue?vue&type=style&index=1&id=ab0f23d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0f23d4",
  null
  
)

export default component.exports